import React from 'react';
import './Hero.css';
import OptimizedImage from '../OptimizedImage/OptimizedImage';

const Hero: React.FC = () => {
  const scrollToPortfolio = () => {
    const portfolioSection = document.querySelector('.portfolio-preview-wrapper');
    if (portfolioSection) {
      portfolioSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section id="home" className="home-wrapper">
      <div className="container">
        <div className="hw-content">
          <div className="hw-heading">
            <h1>Let the <span id="gold">architecture</span> tell its captivating story.</h1>
            <p className="hero-subtitle">
              Transforming spaces into extraordinary experiences through innovative design and sustainable architecture.
            </p>
            
            <div className="hw-b-button">
              <div className="button-wrapper" onClick={scrollToPortfolio}>
                <div className="b-icon">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M19 14l-7 7m0 0l-7-7m7 7V3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="b-button">
                  <button>
                    <h4>Explore Our Work</h4>
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <div className="hw-banner">
            <div className="hw-b-image">
              <OptimizedImage
                src="/assets/images/kitchen_l/kitchen_l_1_compressed.png"
                alt="BlueLake Architecture"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;